// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3C9Q3","footer":"ChangeClinic_footer__3snmJ"};